import { GraphQLClient } from "graphql-request";

const Client = new GraphQLClient("https://graphqlbackend.netlify.app/");

export default Client;

//   http://localhost:4000/
